export default __webpack_public_path__ + "static/media/Linero5.0e401cd0.png";